import Progress from './progress';
export default Progress;


//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_antd@3.9.3@antd/es/progress/index.js
// module id = 319
// module chunks = 0